<template lang="pug">
.btnToolbar
  .editBox__icon
    a(href="#" @click="showModal")
      i.fa(:class="iconClass").fa-fw
  documents-options-modal-vue(
    ref="options_modal"
    v-bind="documentData"
    :selected-option="option"
    :visible-options="[option]"
  )
</template>

<script>
import { mapState } from 'vuex'

const CLASS_MAP = {
  download: 'download',
  share: 'envelope',
  print: 'print'
}

export default {
  name: 'documents-options-button-vue',
  props: {
    option: { type: String, default: 'download' },
    document: { type: Object, default: () => { return {} } }
  },
  components: {
    'documents-options-modal-vue': () => import(/* webpackChunkName: "[request]" */ 'components/documents/OptionsModal')
  },
  computed: {
    iconClass() {
      return `fa-${CLASS_MAP[this.option]}`
    },
    ...mapState('document', [
      'id',
      'numeroTol',
      'clazz',
      'headerFields',
      'metadataFields',
      'indiceFields',
      'bodyFields',
      'fileFields'
    ]),
    documentData() {
      return {
        id: this.document.id || this.id,
        numeroTol: this.document.numeroTol || this.numeroTol,
        clazz: this.document.clazz || this.clazz,
        headerFields: this.document.headerFields || this.headerFields,
        metadataFields: this.document.metadataFields || this.metadataFields,
        indiceFields: this.document.indiceFields || this.indiceFields,
        bodyFields: this.document.bodyFields || this.bodyFields,
        fileFields: this.document.fileFields || this.fileFields,
      }
    }
  },
  methods: {
    showModal() {
      this.$refs.options_modal.showModal()
    }
  }
}
</script>
